__webpack_require__.p = "/static-spa/";